module.exports = __webpack_public_path__ + "static/media/main_phone_en.6bbc5756.svg";